import { Select } from 'antd';
import { memo, useEffect, useState } from 'react';
import { S2MosaicType, S2MosaicTypeModelUtil } from '~/common/typescript/apis/S2MosaicAPIs';

export interface S2MosaicTypeSelectorProps {
  defaultValue?: S2MosaicType;
  value?: S2MosaicType;
  onChange: (value: S2MosaicType) => void;
}

interface OptionType {
  label: string;
  value: S2MosaicType;
}

const S2MosaicTypeSelector = (props: S2MosaicTypeSelectorProps) => {
  const [options, setOptions] = useState<OptionType[]>();

  useEffect(() => {
    const mosaicTypeOptions: OptionType[] = [
      { label: S2MosaicTypeModelUtil.getDescription(S2MosaicType.Month), value: S2MosaicType.Month },
      { label: S2MosaicTypeModelUtil.getDescription(S2MosaicType.Day), value: S2MosaicType.Day },
      { label: S2MosaicTypeModelUtil.getDescription(S2MosaicType.Year), value: S2MosaicType.Year },
    ];
    setOptions(mosaicTypeOptions);
  }, []);

  const onChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value as S2MosaicType);
    }
  };

  const onSearch = (value: string) => {
    // console.log('search:', value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Select
      showSearch
      placeholder="Chọn loại ảnh ghép S2"
      optionFilterProp="children"
      onChange={onChange}
      onSearch={onSearch}
      filterOption={filterOption}
      options={options}
      value={props.value ?? props.defaultValue}
      style={{ width: '100%' }}
    />
  );
};

export default memo(S2MosaicTypeSelector);